import React from "react";
import XLogo from "./images/X_logo_white_512px.png";

export default function Footer() {
	return (
		<footer className="w-full font-sans py-6">
			<div className="flex items-center justify-center gap-2 max-w-5xl mx-auto px-4">
				<span className="text-sm text-neutral-500 flex items-center">
					Made with <span className="mx-1 text-red-500">❤️</span> by Mr.Nob! | join on
					<a href="https://x.com/MrDotNobi" target="_blank" rel="noopener noreferrer" className="flex items-center ml-1 underline hover:text-white transition group">
						<img src={XLogo} alt="X (Twitter) logo" className="w-5 h-5 ml-1 opacity-60 group-hover:opacity-100 transition" style={{ display: "inline", verticalAlign: "middle" }} />
					</a>
				</span>
			</div>
		</footer>
	);
}
